import { acquisitionFor, channelLabel, parameterText } from "./UserAcquisition";

export function userSearchText(user, addonDetails = {}) {
  const attributes = user?.attributes_parsed || {};
  const given = attributes["custom:given_name"] || attributes.given_name || "";
  const family = attributes["custom:family_name"] || attributes.family_name || "";
  const acquisition = acquisitionFor(user);
  const visits = [
    acquisition?.first_touch,
    acquisition?.last_non_direct_touch,
    acquisition?.signup_session,
  ];
  const addons = (user?.addons || []).flatMap((addon) => [
    addon.addonid,
    addonDetails[addon.addonid]?.name,
    addonDetails[addon.addonid]?.addon_name,
  ]);

  return [
    `${given} ${family}`.trim(),
    attributes.name,
    user?.name,
    attributes.email,
    user?.email,
    user?.Username,
    user?.username,
    attributes.sub,
    user?.subscription?.status === "active" ? user?.subscription?.plan || "Free" : "Free",
    ...addons,
    acquisition?.signup_page,
    ...visits.flatMap((visit) => visit ? [
      channelLabel(visit.channel),
      visit.landing_page,
      visit.referrer,
      visit.referring_domain,
      parameterText(visit.utm),
      parameterText(visit.click_ids),
    ] : []),
  ].filter(Boolean).join(" ").toLocaleLowerCase();
}
